var exports = {
  "K": "universeBackground__IScYN1",
};

module.exports = exports;
